export default "__VITE_ASSET__887cc843__"